<template>
    <label :class="classList">
        <div class="af-apple-switch__container">
            <input
                @change="$emit('input', $event.target.checked)"
                :checked="value"
                type="checkbox"
            >
            <span class="af-apple-switch__handler">
                <span class="af-apple-switch__circle">
                    <slot
                        v-if="value"
                        name="on"
                    />
                    <slot
                        v-if="!value"
                        name="off"
                    />
                </span>
            </span>
        </div>
    </label>
</template>

<script>
    export default {
        name: 'C1AppleSwitch',

        props: {
            value: {
                type: [Boolean, String, Number],
                default: '',
            },

            size: {
                type: String,
                default: 'md',
                validator: (value) => {
                    return ['xs', 'sm', 'md', 'lg'].indexOf(value) !== -1;
                },
            },
        },

        data() {
            return {
            };
        },

        computed: {
            classList() {
                return [
                    'af-apple-switch',
                    this.getSize,
                ];
            },

            getSize() {
                return this.size ? `af-apple-switch--${this.size}` : '';
            },
        },
    };
</script>

<style lang="scss" scoped>
    $apple-switch-width-lg: 65px !default;
    $apple-switch-height-lg: 40px !default;
    $apple-switch-width: 48px !default;
    $apple-switch-height: 28px !default;
    $apple-switch-width-sm: 32px !default;
    $apple-switch-height-sm: 20px !default;
    $apple-switch-width-xs: 25px !default;
    $apple-switch-height-xs: 15px !default;

    @mixin apple-switch-size($with: $apple-switch-width, $height: $apple-switch-height) {
        height: $height;
        width: $with;

        .af-apple-switch__circle {
            height: $height - 4;
            left: 2px;
            top: 2px;
            width: $height - 4;
        }

        input[type=checkbox]:checked + .af-apple-switch__handler {
            background-color: #4a90e2;

            .af-apple-switch__circle {
                // stylelint-disable-next-line
                left: calc(100% - #{$height - 2});
            }
        }
    }

    .af-apple-switch {
        display: block;
        margin: 0;
        padding: 0;
        position: relative;

        @include apple-switch-size;

        input[type=checkbox] {
            height: 0;
            opacity: 0;
            width: 0;
        }
    }

    .af-apple-switch__container {
        height: 100%;
        position: relative;
    }

    .af-apple-switch--xs {
        @include apple-switch-size($apple-switch-width-xs, $apple-switch-height-xs);
    }

    .af-apple-switch--sm {
        @include apple-switch-size($apple-switch-width-sm, $apple-switch-height-sm);
    }

    .af-apple-switch--lg {
        @include apple-switch-size($apple-switch-width-lg, $apple-switch-height-lg);
    }

    .af-apple-switch__handler {
        background-color: #ccd4dc;
        border-radius: 20px;
        bottom: 0;
        cursor: pointer;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: left 0.4s;
    }

    .af-apple-switch__circle {
        align-items: center;
        background-color: white;
        border-radius: 50%;
        display: flex;
        height: $apple-switch-height - 4;
        justify-content: center;
        left: 2px;
        position: absolute;
        text-align: center;
        top: 2px;
        transition: left 0.4s;
        width: $apple-switch-height - 4;
    }
</style>
